import type { Permission, Role, User } from "../types";

export const ROLE_LABELS: Record<Role, string> = {
  sysadmin: "System Administrator",
  executive: "Executive",
  director: "Director",
  leader: "Leader",
  fabricator: "Fabricator",
  client: "Client",
};

export const ALL_ROLES = Object.keys(ROLE_LABELS) as Role[];

export const INTERNAL_ROLES: Role[] = [
  "sysadmin",
  "executive",
  "director",
  "leader",
  "fabricator",
];

export function effectiveRoles(user: User | null | undefined): Role[] {
  if (user?.roles?.length) return user.roles;
  return user?.role === "admin"
    ? ["sysadmin"]
    : user?.role === "supervisor"
      ? ["leader"]
      : user?.role
        ? [user.role]
        : [];
}

export function userHasRole(user: User | null | undefined, ...roles: Role[]) {
  return roles.some((role) => effectiveRoles(user).includes(role));
}

export function userHasPermission(
  user: User | null | undefined,
  permission: Permission,
) {
  if (!user?.permissions) {
    if (user?.role === "admin") return true;
    if (user?.role === "supervisor") {
      return ["user.view", "project.view", "project.create", "project.edit", "task.view", "task.create", "task.edit"].includes(permission);
    }
  }
  return Boolean(
    user?.permissions?.includes("*") || user?.permissions?.includes(permission),
  );
}

export function displayRoles(user: User): string[] {
  return effectiveRoles(user).map((role) => ROLE_LABELS[role]);
}

export function canAccessSettings(user: User | null | undefined): boolean {
  return userHasRole(user, ...INTERNAL_ROLES);
}
